<template>
  <div class="py-5 md:px-5">
    <PageHeader class="max-w-4xl" :title="`${$route.params.id ? 'Edit' : 'Create'} Address`" :back-step="true" />
    
    <div class="max-w-4xl mx-auto">
      <div class="p-6 card">
        <Loading v-if="$route.params.id && loading" />
        <div v-else class="grid gap-4 divide-y">
          <div class="text-lg leading-5">
            <div class="font-bold">
              {{ form.name }}
            </div>
            <div class="text-gray-500">
              {{ form.number }}
            </div>
          </div>
          <div class="pt-4">
            <div class="text-xs tracking-wider text-gray-500 uppercase">
              Contact
            </div>
            <div>
              {{ form.contact_name }}
            </div>
            <div>
              {{ form.contact_email }}
            </div>
            <div>
              {{ form.contact_phone }}
            </div>
          </div>
          <div class="pt-4">
            <div class="text-xs tracking-wider text-gray-500 uppercase">
              Location
            </div>
            <div>
              {{ form.address_1 }}
            </div>
            <div>
              {{ form.address_2 }}
            </div>
            <div>
              {{ form.city }}
            </div>
            <div>
              {{ form.province }}
            </div>
            <div>
              {{ form.country }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AddressForm',

  created () {
    if (this.$route.params.id) {
      this.getAddress()
    }
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      loading: true,
      form: {}
    }
  },

  methods: {
    async getAddress () {
      try {
        const { data } = await this.$api.get(`/account/${this.$route.params.account}/addresses/${this.$route.params.id}`)
        this.form = data.address
        this.loading = false
      } catch (error) {
        this.$toasted.error('There was a problem fetching this address.')
        console.error(error)
      }
    },
  }
}
</script>
